import { ReferralType } from '~/types/referral';
import type { SpecialtyFormConfig } from '~/types/specialty';
import { DentalSpecialty } from '~/types/specialty';

/**
 * Configuration for Hospital Dentist specialty referral form
 */
export const hospitalConfig: SpecialtyFormConfig = {
  specialty: DentalSpecialty.HOSPITAL,
  displayName: 'Hospital Dentist',
  requiresToothSelection: true,
  requiresEmail: true,
  reasonSelectorHeading: 'Choose a Medical Reason',
  referralTypes: [
    ReferralType.URGENT,
    ReferralType.ROUTINE,
    ReferralType.SYMPTOMATIC,
    ReferralType.ELECTIVE,
    ReferralType.CONSULTATION,
  ],
  diagnosisOptions: [],
};
